(function() {
  'use strict';

  angular
    .module('admin.trades.service', [])
    .factory('TradesService', TradesService);

  /** @ngInject */
  function TradesService($http, $q, API) {

    function list(){
        var defered = $q.defer();

        $http.get(API.API_URL + 'trade_posts')
          .success(defered.resolve);

        return defered.promise;
    }

    return{
        list: list
    };

  }

})();
